module.exports = "/report-9695711c027ecaf4a68230973c12fe74.svg";